export default {
  header: {
    about: 'About Us',
    contact: 'Contact',
    solutions: 'Solutions',
    platform: 'Platform',
  },
  hero: {
    title: 'Next-Gen Lens-Free Sensing Technology',
    subtitle: 'AI Vital Sign Detection・Smart Indoor & Outdoor Protection',
    description: 'Ailicorn leverages industry-leading AI models to provide enterprises with precise, fast, and secure fall detection services',
    learnMore: 'Learn More'
  },
  seo: {
    home: {
      title: 'AI Millimeter-Wave Fall Detection Platform',
      description: 'AIlicorn delivers privacy-first millimeter-wave sensing to automate fall detection, vital sign monitoring, and facility safety compliance for healthcare, senior care, and smart buildings.',
      keywords: 'AI fall detection, millimeter wave sensing, contactless monitoring, AIlicorn'
    },
    team: {
      title: 'AIlicorn Leadership & AI Experts',
      description: 'Meet the founders and AI engineers behind AIlicorn who design privacy-first fall detection and sensing solutions.',
      keywords: 'AIlicorn team, AI engineers, founders, leadership'
    },
    contact: {
      title: 'Contact AIlicorn',
      description: 'Reach the AIlicorn team to schedule a demo, discuss partnerships, or deploy enterprise fall detection systems.',
      keywords: 'contact AIlicorn, fall detection demo, enterprise AI sensing'
    }
  },
  team: {
    hero: {
      title: 'Our Team',
      subtitle: 'A team of passionate tech experts and innovative thinkers,\nbuilding industry-leading AI recognition solutions',
      stats: {
        clients: 'Client Partners',
        awards: 'Industry Awards',
        members: 'Team Members'
      }
    },
    members: {
      liberty: {
        name: 'Liberty',
        title: 'Founder & CEO',
        description: 'With a background in Computer Science from NCU, Liberty has won numerous startup competitions including the Cross-Strait Startup Competition Gold Award. A serial entrepreneur passionate about applying AI technology to real-life scenarios.',
        skills: ['Innovation', 'AI Startup', 'Business Strategy']
      },
      samuel: {
        name: 'Samuel',
        title: 'COO',
        description: 'Senior Manager at StarCharge Energy, former COO at BitThinking Technology and Deputy Manager at YiYang Technology. Rich experience in product and operations management, focused on improving team efficiency and product value.',
        skills: ['Operations', 'Product Design', 'Tech Leadership']
      },
      vince: {
        name: 'Vince',
        title: 'Senior AI Engineer',
        description: 'Graduate of NCU Computer Science, with years of AI model development experience. Focused on deep learning and computer vision technology applications, dedicated to transforming advanced AI technology into practical products.',
        skills: ['AI Technology', 'Deep Learning', 'Signal Processing']
      }
      ,
      person4: {
        name: 'person4',
        title: '資深 AI 工程師',
        description: '中央大學資工系畢業，擁有多年AI模型開發經驗，專注於深度學習與電腦視覺技術的應用，致力於將先進的AI技術轉化為實際產品。',
        skills: [
          'AI 技術',
          '深度學習',
          '訊號處理'
        ]
      },
      person5: {
        name: 'person5',
        title: '資深 AI 工程師',
        description: '中央大學資工系畢業，擁有多年AI模型開發經驗，專注於深度學習與電腦視覺技術的應用，致力於將先進的AI技術轉化為實際產品。',
        skills: [
          'AI 技術',
          '深度學習',
          '訊號處理'
        ]
      }
    }
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Fill out the form to get in touch with us, we will respond as soon as possible',
    loading: 'Loading...'
  },
  features: {
    title: 'Why Choose Ailicorn',
    subtitle: 'Professional AI Recognition Technology Creating More Value for Your Business',
    items: {
      precision: {
        title: 'Precision Processing',
        description: 'Utilizing advanced AI technology for high-precision signal processing and deep learning, ensuring accuracy and security of every piece of data.'
      },
      api: {
        title: 'API Integration Platform',
        description: 'Providing comprehensive API interface services for easy integration with existing systems and rapid implementation of intelligent applications.'
      },
      privacy: {
        title: 'Privacy Guarantee',
        description: 'No cameras, no identity verification - complete user privacy protection for peace of mind while using our services.'
      }
    }
  },
  awards: {
    title: 'Awards & Recognition',
    subtitle: 'Our technology excellence continues to drive industry innovation',
    linkLabel: 'Read more',
    items: {
      meet_taipei: {
        title: 'Featured by Meet',
        subtitle: 'No wearables, no cameras! AIlicorn leverages millimeter-wave radar technology to create a seamless and privacy-preserving care system',
        url: 'https://meet.bnext.com.tw/articles/view/53293?'
      },
      ces: {
        title: '2026 Consumer Electronics Show(CES)',
        subtitle: 'Exhibited in the United States',
        url: 'https://www.nhks.com.tw/%E9%83%A8%E8%90%BD%E6%A0%BC/%E7%86%B1%E9%96%80%E8%A9%B1%E9%A1%8C/2026%E7%BE%8E%E5%9C%8B%E6%B6%88%E8%B2%BB%E9%9B%BB%E5%AD%90%E5%B1%95ces%E5%8F%B0%E7%81%A3%E5%8F%83%E5%B1%95%E5%BB%A0%E5%95%86%E5%90%8D%E5%96%AE%E5%A4%A7%E5%85%AC%E9%96%8B/'
      },
      fiti: {
        title: '2024 FITI Innovation & Entrepreneurship Program',
        category: 'Startup Potential Award',
        url: 'https://twpowernews.com/news_pagein.php?iType=1009&n_id=270806'
      },
      innoserve: {
        title: '2024 Vivatech',
        category: 'Silver Medal'
      },
      csmu: {
        title: '2023 CSMU National Innovation & Entrepreneurship Competition',
        category: 'First Place in Creative Entrepreneurship'
      },
      cht5g: {
        title: '2023 CHT 5G Smart Innovation Application Competition',
        category: 'Best Application Award - Campus Division'
      }
    }
  },
  technology: {
    title: 'Core Technology',
    subtitle: 'Industry-Leading AI Millimeter Wave Technology',
    items: {
      fallDetection: {
        title: 'Highly Precise Fall Detection',
        description: 'AIlicorn\'s millimeter wave technology can be applied in any scenario, providing minimal false alarms to reduce fall-related injuries.',
        altText: 'Fall Detection Technology'
      },
      humanRecognition: {
        title: 'Human Recognition System',
        description: 'Camera-free, ensuring perfect privacy while simulating human movement paths. Suitable for various security monitoring and medical applications.',
        altText: 'Skeleton Detection Technology'
      }
    }
  },
  footer: {
    description: 'Leading AIoT fall detection technology provider, committed to delivering professional smart solutions for enterprises.',
    sections: {
      about: {
        title: 'About Us',
        team: 'Our Team'
      },
      services: {
        title: 'Services',
        processing: 'Precision Processing',
        api: 'API Integration',
        evidence: 'Electronic Evidence',
        custom: 'Custom Solutions'
      },
      contact: {
        title: 'Contact',
        email: 'service@ailicorn.com',
        address: '5F., No. 60, Mingde Rd., Zhongli Dist., Taoyuan City',
        contactUs: 'Contact Us'
      }
    },
    copyright: '© 2025 Ailicorn Inc. All rights reserved.'
  }
};
